import { AsyncPipe } from '@angular/common';
import { Component, viewChild } from '@angular/core';
import { MatAnchor, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AppToolbarDividerComponent } from '../../../shared/components/app-toolbar-divider/app-toolbar-divider.component';
import { MenuComponent } from '../../components/menu/menu.component';
import { NavigationBaseComponent } from '../navigation-base/navigation-base.component';
import { NavigationToolbarComponent } from '../navigation-toolbar/navigation-toolbar.component';

@Component({
  selector: 'lfw-topbar-navigation',
  templateUrl: './topbar-navigation.component.html',
  styleUrls: ['./topbar-navigation.component.scss'],
  imports: [
    NavigationToolbarComponent,
    MatIconButton,
    MatAnchor,
    MatIcon,
    MenuComponent,
    RouterLinkActive,
    RouterLink,
    MatTooltip,
    MatSidenavContainer,
    MatSidenav,
    MatNavList,
    MatListItem,
    MatSidenavContent,
    AsyncPipe,
    AppToolbarDividerComponent
  ]
})
export class TopbarNavigationComponent extends NavigationBaseComponent {
  protected readonly sidenav = viewChild.required<MatSidenav>('sidenav');

  get isInfoBarVisible(): boolean {
    return !this.settingsService.settings.viewMode.isFullScreen && !this.settingsService.runningInWindowMode();
  }
}
